module.exports = "/assets/data/7eb10767e4f4ca6a0dad3c23da3e7adf-LS15.data.json";